'use client'

import {useState} from 'react'
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/react'
import {
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,
    SquaresPlusIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import {ChevronDownIcon, PhoneIcon, PlayCircleIcon, RectangleGroupIcon} from '@heroicons/react/20/solid'
import BtnCart from "app/modules/layout/templates/nav/BtnCart";
import BtnAccount from "app/modules/layout/templates/nav/BtnAccount";

const products = [
    {
        name: 'Все категории',
        description: '',
        href: '/shop',
        icon: '/shop/35d07790fe7e6475df3d524b2267bb33f7c7d19750d680b92095e2d233b58f44.png',
    },
    {
        name: 'Кольца',
        description: '',
        href: '/shop/category/koltsa',
        icon: '/shop/qqt1p9ho8r7kfia6ma37ueujtl6agqz2.webp',
    },
    {
        name: 'Серьги',
        description: '',
        href: '/shop/category/sergy',
        icon: '/shop/qqt1p9ho8r7kfia6ma37ueujtl6agqz2.webp',
    },
    {name: 'Подвески', description: '', href: '/shop/category/podveski', icon: '/shop/qqt1p9ho8r7kfia6ma37ueujtl6agqz2.webp'},
    {
        name: 'Цепи',
        description: '',
        href: '/shop/category/tsepi',
        icon: '/shop/qqt1p9ho8r7kfia6ma37ueujtl6agqz2.webp',
    },
    {
        name: 'Браслеты',
        description: '',
        href: '/shop/category/braslety',
        icon: '/shop/qqt1p9ho8r7kfia6ma37ueujtl6agqz2.webp',
    },
]
const callsToAction = [
    {name: 'Watch demo', href: '#', icon: PlayCircleIcon},
    {name: 'Contact sales', href: '#', icon: PhoneIcon},
    {name: 'View all products', href: '#', icon: RectangleGroupIcon},
]
const navigationLeft = [
    {name: '8 (800) 555-05-29', href: 'tel:88005550529'},
]
const navigation = [
    {name: 'Доставка и оплата', href: '#'},
]
export default function Example() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    return (
        <>
            <nav aria-label="Global"
                 className="hidden lg:flex mx-auto max-w-[1536px] items-center justify-between pt-3 px-3 md:px-6">
                <div className="flex flex-1">
                    <div className="hidden lg:flex lg:gap-x-6">
                        {navigationLeft.map((item) => (
                            <a key={item.name} href={item.href} className="text-sm/7 text-gray-500">
                                {item.name}
                            </a>
                        ))}
                    </div>
                </div>
                <a href="/" className="-m-1.5 p-1.5">
                    <span className="text-2xl">WGP Shop</span>
                </a>
                <div className="flex-1 justify-end hidden lg:flex lg:gap-x-6">
                    {navigation.map((item) => (
                        <a key={item.name} href={item.href} className="text-sm/7 text-gray-500">
                            {item.name}
                        </a>
                    ))}
                </div>
            </nav>
            <header className="relative isolate z-10 bg-white">
                <nav aria-label="Global"
                     className="mx-auto flex max-w-[1536px] items-center justify-between py-5 px-3 md:px-6">
                    <div className="flex lg:hidden">
                        <a href="/" className="-m-1.5 p-1.5">
                            <span className="text-2xl">WGP Shop</span>
                        </a>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="size-6"/>
                        </button>
                    </div>
                    <PopoverGroup className="hidden lg:flex lg:gap-x-8">
                        <Popover>
                            <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                Каталог
                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400"/>
                            </PopoverButton>

                            <PopoverPanel
                                transition
                                className="absolute inset-x-0 top-0 -z-10 bg-white pt-14 shadow-lg ring-1 ring-gray-900/5 transition data-closed:-translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                            >
                                <div
                                    className="mx-auto grid max-w-[1536px] grid-cols-4 xl:grid-cols-6 gap-x-4 px-6 py-10 lg:px-8 xl:gap-x-8">
                                    {products.map((item) => (
                                        <div key={item.name}
                                             className="group relative rounded-lg p-6 text-sm/6 hover:bg-gray-50">
                                            <div
                                                className="flex size-20 items-center justify-center rounded-full bg-gray-50 group-hover:bg-white">
                                                <img src={item.icon} className={'rounded-full overflow-hidden'}/>
                                                {/*    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                        */}</div>
                                            <a href={item.href} className="mt-6 block font-semibold text-gray-900">
                                                {item.name}
                                                <span className="absolute inset-0"/>
                                            </a>
                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                        </div>
                                    ))}
                                </div>
                                <div className="bg-gray-50 hidden">
                                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                        <div
                                            className="grid grid-cols-3 divide-x divide-gray-900/5 border-x border-gray-900/5">
                                            {callsToAction.map((item) => (
                                                <a
                                                    key={item.name}
                                                    href={item.href}
                                                    className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-100"
                                                >
                                                    <item.icon aria-hidden="true"
                                                               className="size-5 flex-none text-gray-400"/>
                                                    {item.name}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </PopoverPanel>
                        </Popover>

                        <a href="#" className="text-sm/6 font-semibold text-gray-900">
                            Новинки
                        </a>
                        <a href="#" className="text-sm/6 font-semibold text-gray-900">
                            Акции
                        </a>
                    </PopoverGroup>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end gap-6">
                        <BtnAccount/>
                        <BtnCart/>
                    </div>
                </nav>
                <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                    <div className="fixed inset-0 z-10"/>
                    <DialogPanel
                        className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex items-center justify-between">
                            <a href="#" className="-m-1.5 p-1.5">
                                <span className="text-2xl">WGP Shop</span>
                            </a>
                            <button
                                type="button"
                                onClick={() => setMobileMenuOpen(false)}
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon aria-hidden="true" className="size-6"/>
                            </button>
                        </div>
                        <div className="mt-6 flow-root">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="space-y-2 py-6">
                                    <Disclosure as="div" className="-mx-3">
                                        <DisclosureButton
                                            className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                            Каталог
                                            <ChevronDownIcon aria-hidden="true"
                                                             className="size-5 flex-none group-data-open:rotate-180"/>
                                        </DisclosureButton>
                                        <DisclosurePanel className="mt-2 space-y-2">
                                            {[...products].map((item) => (
                                                <DisclosureButton
                                                    key={item.name}
                                                    as="a"
                                                    href={item.href}
                                                    className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                >
                                                    {item.name}
                                                </DisclosureButton>
                                            ))}
                                        </DisclosurePanel>
                                    </Disclosure>
                                    <a
                                        href="#"
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                    >
                                        Новинки
                                    </a>
                                    <a
                                        href="#"
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                    >
                                        Акции
                                    </a>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </Dialog>
            </header>
        </>
    )
}
